import { render } from "./mvt-welcomeback.vue?vue&type=template&id=303044e8"
import script from "./mvt-welcomeback.js?vue&type=script&lang=js"
export * from "./mvt-welcomeback.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__